ALLOWED_CONTROLLER = 'reports'
ALLOWED_ACTIONS = ['locations']

ready = ->
  return unless continueIfAllowed(ALLOWED_CONTROLLER, ALLOWED_ACTIONS)

  load_from_id_fields = ->
    for key, value of ids
      node_ids = $('#' + key).val().trim()
      if node_ids == ''
        continue
      node_ids = node_ids.split('.')
      for node_id in node_ids
        selector = '[data-id="' + node_id + '"][data-type="' + key + '"]'
        node = $(selector)
        node.data('jstree', {'selected': true})

  save_into_id_fields = ->
    jstree = $.jstree.reference('#location_choices')
    checked_nodes = jstree.get_checked(true)
    for node in checked_nodes
      parent_selected = false
      for parent_id in node.parents
        if parent_id != '#'
          if jstree.is_selected(parent_id)
            parent_selected = true
            break
      if !parent_selected
        ids[node.data.type].push(node.data.id)
    for key, value of ids
      $('#' + key).val(value.join('.'))


  options = {
    plugins: ["checkbox", "sort"],
    checkbox: {
      real_checkboxes: true,
      real_checkboxes_names: (n) ->
        elt = $(n[0])
        [elt.attr("data-type")+"[]", elt.attr("data-id")]
    }
  }
  ids = {
    'cluster_ids': [],
    'location_ids': []
    'ui_node_ids': [],
    'kiosk_ids': [],
    'access_hub_ids': [],
    'bike_hangar_ids': [],
    'g7_space_ids': [],
    'owner_ids': []
  }
  load_from_id_fields()
  jstree = $("#location_choices").jstree(options)
  $('form').on('submit', save_into_id_fields)


$(document).ready(ready)
$(document).on('turbo:load', ready)
$(document).on('jstree-location-reports', ready)
